import { useTranslation } from "react-i18next";
import Modal from "@cloudscape-design/components/modal";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Button from "@cloudscape-design/components/button";
import Alert from "@cloudscape-design/components/alert";

function GatewayTargetDeleteModal({ target, onConfirm, onCancel, visible, loading }) {
  const { t } = useTranslation();

  return (
    <Modal
      visible={visible}
      onDismiss={onCancel}
      header={t("gateway-targets.delete.title")}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onCancel} disabled={loading}>
              {t("gateway-targets.delete.cancel")}
            </Button>
            <Button variant="primary" onClick={onConfirm} loading={loading}>
              {t("gateway-targets.delete.confirm")}
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="m">
        <Alert type="warning">{t("gateway-targets.delete.warning")}</Alert>
        <Box>{t("gateway-targets.delete.message", { name: target?.name || "" })}</Box>
      </SpaceBetween>
    </Modal>
  );
}

export default GatewayTargetDeleteModal;
